import React from 'react';
import './ModuleContact.css';
import * as icones from '../Icones'
import * as tools from '../Tools';

export class ModuleContact extends React.Component {
	render() {
		const data = this.props.data;

		return (
			<div className="col-xl-3 bg-gris4">
				<section className="text-center pt-lg-5 pb-lg-5 pt-3 pb-3">
					{/* LOGO */}
					{/* <img
						// src={require(`../../resources/icons/icone_contact.svg`)}
						src=""
						className="img-fluid pt-5"
						style={{ height: '150px' }}
					/> */}
					<icones.contact className="img-fluid pt-5" />



					{/* Titre */}
					<div className="pt-5" style={{ fontSize: '1.6em' }}>
						CONTACT
					</div>

					{/* Adresse */}
					<div className="ft-parisienne pt-4" style={{ fontSize: '1.3em' }}>
						{data.titreAdresse}
					</div>
					<div className="text-center pt-3">
						{data.adresse.map(element => {
							return (
								<div className="ft-alegreya-sans-regular" style={{}}>
									{element}
								</div>
							);
						})}
					</div>

					{/* Barre blanche */}
					<div className="pt-3" style={{}}>
						<div
							style={{
								height: '3px',
								width: '30px',
								marginLeft: 'auto',
								marginRight: 'auto'
							}}
							className="bg-white"
						></div>
					</div>

					{/* Telephone */}
					<div className="text-center pt-3">
						{data.tel.map(element => {
							return <div className="texte">{element}</div>;
						})}
					</div>

					{/* Mail */}
					<div className="text-center pt-3">
						{data.mail.map(element => {
							return <div className="text-white texte">{element}</div>;
						})}
					</div>

					{/* Url */}
					<div className="text-center pt-3">
						<div className="text-white texte">{data.url}</div>
					</div>

					{data.lienMap && <div style={{}} className="mt-lg-5 pt-lg-5 pb-lg-5 mt-3 pt-3 pb-5">
						<a
							class="text-center mt-3 mt-lg-5 ft-lato-light"
							href={data.lienMap}
							style={{
								padding: '5%',
								fontSize: '110%',
								color: '#fff',
								border: '1px solid #fff'
							}}
							target="_blank"
						>
							VOIR LA CARTE
						</a>
					</div>}
				</section>
			</div>
		);
	}
}
